import request from '@/utils/request'


// 查询产品列表
export function listGoods(query) {
  return request({
    url: '/user/goods/list',
    method: 'get',
    params: query
  })
}

// 查询产品分页
export function pageGoods(query) {
  return request({
    url: '/user/goods/page',
    method: 'get',
    params: query
  })
}

// 查询产品详细
export function getGoods(data) {
  return request({
    url: '/user/goods/detail',
    method: 'get',
    params: data
  })
}

// 新增产品
export function addGoods(data) {
  return request({
    url: '/user/goods/add',
    method: 'post',
    data: data
  })
}

// 修改产品
export function updateGoods(data) {
  return request({
    url: '/user/goods/edit',
    method: 'post',
    data: data
  })
}

// 仅更新排序（不走 edit）
export function updateGoodsSort(data) {
  return request({
    url: '/user/goods/update-sort',
    method: 'post',
    data: data
  })
}

// 仅更新状态（不走 edit）
export function updateGoodsStatus(data) {
  return request({
    url: '/user/goods/update-status',
    method: 'post',
    data: data
  })
}

// 删除产品
export function delGoods(data) {
  return request({
    url: '/user/goods/delete',
    method: 'post',
    data: data
  })
}
